document.addEventListener("DOMContentLoaded", code);

if (window.acf) {
  window.acf.addAction('render_block_preview/type=eco-system-block', code);
}

function code(event) {
  // Function to handle section title click
  function handleSectionTitleClick(event) {
    if (!event.target.matches(".eco-section-title")) return; // Check if the clicked title is already open

    var isOpen = event.target.classList.contains("opened"); // Remove the "open" class before adding the "opened" class

    document.querySelectorAll(".eco-section-title.opened").forEach(function (el) {
      el.classList.remove("opened");
      el.parentNode.classList.remove("opened");
      el.ariaExpanded = "false";
    }); // If the clicked title was not already open, add the "opened" class

    if (!isOpen) {
      event.target.classList.add("opened");
      event.target.parentNode.classList.add("opened");
      event.target.ariaExpanded = "true"; // Add the "show" class to the element with id "clearEcoSelection"

      document.getElementById("clearEcoSelection").classList.add("show"); // Get the data-video attribute value

      var videoSrc = event.target.getAttribute("data-video"); // Update video source

      updateVideoSource(videoSrc);
    } else {
      // Remove the "show" class to the element with id "clearEcoSelection"
      document.getElementById("clearEcoSelection").classList.remove("show");
      updateVideoSource(document.getElementById("clearEcoSelection").getAttribute("data-video"));
    }
  }

  function updateVideoSource(videoSrc) {
    // Reference to the video elements
    var currentVideo = document.querySelector(".eco-video.current");
    var backupVideo = document.querySelector(".eco-video.backup"); // Ensure there's a video source to update to

    if (videoSrc) {
      var backupSource = backupVideo.querySelector("source");
      backupSource.src = videoSrc; // Temporarily remove the event listener to avoid multiple bindings

      backupVideo.removeEventListener("loadeddata", onBackupVideoLoaded); // Add the event listener back with the updated function

      backupVideo.addEventListener("loadeddata", onBackupVideoLoaded); // Start loading the new source

      backupVideo.load();
    }
  } // Function to handle when the backup video has loaded


  function onBackupVideoLoaded() {
    var currentVideo = document.querySelector(".eco-video.current");
    var backupVideo = document.querySelector(".eco-video.backup"); // Swap classes between current and backup videos

    currentVideo.classList.replace("current", "backup");
    backupVideo.classList.replace("backup", "current"); // Clear the source of the now backup video to be ready for the next source

    var currentSource = currentVideo.querySelector("source");
    currentSource.src = ""; // Reload the now backup video to apply the cleared source

    currentVideo.load(); // Optionally, manage play/pause button visibility

    var playButton = document.getElementById("eco-play");
    var pauseButton = document.getElementById("eco-pause");
    playButton.classList.add('hidden');
    pauseButton.classList.remove('hidden'); // Remove the event listener to prevent it from firing multiple times

    backupVideo.removeEventListener("loadeddata", onBackupVideoLoaded);
  } // Event listener for section title clicks


  document.addEventListener("click", handleSectionTitleClick);
  var clearEcoSelection = document.getElementById("clearEcoSelection");

  if (clearEcoSelection) {
    // Event listener for "clearEcoSelection" click
    clearEcoSelection.addEventListener("click", function (event) {
      // Remove the "opened" classes
      event.preventDefault();
      document.querySelectorAll(".eco-section-title.opened").forEach(function (el) {
        el.classList.remove("opened");
        el.parentNode.classList.remove("opened");
        el.ariaExpanded = "false";
      }); // Remove the "show" class from the element with id "clearEcoSelection"

      clearEcoSelection.classList.remove("show"); // Reset the video src

      updateVideoSource(event.target.getAttribute("data-video"));
    });
  }

  var playButton = document.getElementById("eco-play");
  var pauseButton = document.getElementById("eco-pause"); // Event listener for the play button

  if (playButton) {
    playButton.addEventListener("click", function () {
      var video = document.querySelector(".eco-video.current");
      video.play();
      playButton.classList.add('hidden');
      pauseButton.classList.remove('hidden');
    });
  } // Event listener for the pause button


  if (pauseButton) {
    pauseButton.addEventListener("click", function () {
      var video = document.querySelector(".eco-video.current");
      video.pause();
      pauseButton.classList.add('hidden');
      playButton.classList.remove('hidden');
    });
  }
}